import { Filters } from '../model/search-base-model';


function isMatch(a: any, filters: Filters): boolean {
  let match = true;

  const keys = Object.keys(a);
  let searchMatch = !keys.some(k => filters[k] && filters[k][0]?.searchAble);
  for (let j = 0; j < keys?.length; ++j) {
    const categories = filters[keys[j]];
    const itemValue = a[keys[j]]
    if (!categories || categories?.length === 0 || categories?.some(c => c.value === '')) continue;
    for (let i = 0; i < categories?.length; i++) {
      if (Array.isArray(itemValue)) {
        if (!itemValue.some(a => a?.value === categories[i]?.value || !categories[i]?.value)) {
          match = false;
          break;
        }
      }
      if (typeof itemValue === 'string' || itemValue instanceof String) {
        searchMatch = searchMatch || itemValue?.toLocaleLowerCase().includes(categories[i]?.value)
      }
    }
    if (!match) break;
  }
  return match && searchMatch;
}


export const filterList = (list: any[], filters: Filters): any[] => {
  if (!filters || Object.keys(filters)?.length === 0) {
    return list;
  }
  return list?.filter(a => isMatch(a, filters));

}

